import { Loading } from 'carbon-components-react'
import React from 'react'

export default () => (
    <div style={{width: '100%', height: '100%', flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
        <Loading withOverlay={false} />
    </div>
)